import React, { useRef, useState, useEffect } from 'react';
import "./about.css";
import Navbar from './Navbar';
import BounceLoader from "react-spinners/BounceLoader";
import { gsap } from "gsap";
import Footer from './Footer';
import axios from 'axios';

const About = () => {

    // const baseURL = "https://my-portfolio-5u5m.onrender.com/"
    const baseURL = "http://16.171.64.77/" 
    //  const baseURL = "/api"; // this for proxy url

    const wheelRef = useRef();
    const mainRef = useRef();
    const el = useRef();
    const q = gsap.utils.selector(el);
    const [loading, setLoading] = useState(true);
    const [hideLoader, setHideLoader] = useState(false)
    const [myData, setMyData] = useState({})
    const [myImageUrl, setMyImageUrl] = useState("");

    useEffect(() => {

        window.onscroll = function () {
            wheelRef.current.style.transform = "rotate(" + window.pageYOffset / 2 + "deg)";
        };
    }, [])


    useEffect(() => {
        document.title = "About"
    }, [])

    useEffect(() => {
        const reqURL = `/api/portfolio/about-me/`

        axios.get(reqURL)
            .then(res => {
                setMyData(res.data[0])
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
            })
    }, [])


    useEffect(() => {

        if (!loading) {
            setHideLoader(true)
        }

    }, [loading])

    useEffect(() => {

        const t2 = gsap.timeline()

        t2
            .from(q(".image"), {
                opacity: 0,
                duration: 1
            }, 1.5)
            .from(q(".points li"), {
                opacity: 0,
                y: 50,
                duration: 0.5,
                stagger: 0.1
            }, 2)
            .from(q(".myDescription"), {
                opacity: 0,
                duration: 0.5,
                stagger: 0.1
            })

        return () => {
            t2.kill();
        };
    }, []);

    useEffect(() => {
        if (myData.myImage) {
            const ipRemovedUrl = new URL(myData.myImage).pathname
            const redUrl = '/redapi' + ipRemovedUrl

            setMyImageUrl(redUrl);
        }

    }, [myData, loading])

    return (
        <>
            <div className="preloader" style={{ width: "100%", height: "100vh", background: "black", position: "fixed", top: "0", zIndex: "9999999", opacity: hideLoader && 0, visibility: hideLoader && "hidden", transition: "all 0.5s ease-in-out", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <BounceLoader color="#ff792e" size={100} />
            </div>
            <div ref={mainRef} className="mainCover" style={{ opacity: hideLoader && 1, transition: "all 0.5s ease-in-out" }}>
                <Navbar workRef={mainRef} textcolor="rgb(252, 246, 244)" />

                <section ref={el} className="aboutSection">
                    <div className="aboutHead">
                        <div className="aboutContent">
                            <div className="aboutImgSide">
                                {/* <h1>about.</h1> */}
                                <span className='image'><img className='pic' src={myImageUrl} alt="profilePic" /></span>
                            </div>
                            <div className="aboutPointsSide">
                                <h1>about.</h1>
                                <h2>Hi, there!</h2>
                                <div className='points'>
                                    <ul>
                                        <li>
                                            <i className="fas fa-seedling"></i>
                                            <span>{myData.currentStatus}</span>
                                        </li>
                                        <li>
                                            <i className="fas fa-code"></i>
                                            <span>{myData.codingAchievement}</span>
                                        </li>
                                        <li>
                                            <i className="fas fa-chess-knight"></i>
                                            <span>Leisure game is chess</span>
                                        </li>
                                        <li>
                                            <i className="fas fa-heart"></i>
                                            <span>Love to do Bhangra </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="myDescription">
                        <div className="desHeading">
                            <h1>ReadMe</h1>
                            <div className="underline">
                                <span className="circle"></span>
                                <span className="line"></span>
                            </div>
                        </div>
                        <div className="desPara">
                            {myData.readme ? myData.readme.split("<br>").map((paragraph, index) => {

                                return <p key={index}>{paragraph}</p>
                            }
                            ) : ""}
                        </div>
                        <div className="resume">
                            <p className='askingP'>Want to know more about me? See my resume <span style={{ color: "white" }}> 👉 </span></p>
                            <a href={myData.resume} target='_blank' style={{ textDecoration: "none" }} className="downloadResumeBtn">
                                <span className="btnBG"></span>
                                <p>My Resume</p>
                            </a>
                        </div>
                    </div>
                    <div className="rotationWheel">
                        <i ref={wheelRef} className="fas fa-yin-yang"></i>
                    </div>
                    <Footer />
                </section>
            </div>
        </>
    )
}

export default About;
